export function getContructionWindowOption (width = 20) {
  // const width = document.body.offsetWidth * 0.0164583
  return {
    color: ['#FF8D0B', '#5C94FF'],
    title: {},
    grid: {
      left: width,
      right: width,
      bottom: 25,
      top: 25
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      }
    },
    xAxis: {
      show: false,
      boundaryGap: false,
      data: [1, 2, 3, 4, 5, 6, 7]
    },
    yAxis: {
      show: false,
      min: 9,
      max: 18
    },
    series: [{
      type: 'line',
      name: '最高温度',
      smooth: true,
      data: [14, 13, 18, 16, 13, 17, 14],
      label: {
        show: true,
        position: 'top',
        fontSize: '0.75rem',
        formatter: '{c}℃',
        color: '#FFF'
      }
    }, {
      type: 'line',
      name: '最底温度',
      smooth: true,
      data: [12, 10, 14, 15, 11, 15, 11],
      label: {
        show: true,
        color: '#FFF',
        position: 'bottom',
        fontSize: '0.75rem',
        formatter: '{c}℃'
      }
    }]
  }
}
